import React, { useCallback } from "react";
import styled from "styled-components";
import { State, useState } from "@hookstate/core";
import { PrintAdPage, useExhibitorDataState } from "../../globalStates/ExhibitorDataState";
import Icon from "../../components/Icon";
import DownloadIcon from '../../images/download.svg'
import RemoveIcon from '../../images/remove.svg'
import DummyPreviewIcon from '../../images/dummy.svg'
import PdfPreviewIcon from '../../images/pdf.svg'

function mapSource(filename?: string, source?: string): string {
    if (!filename || !source) return 'none'
    if (filename.endsWith("pdf")) return PdfPreviewIcon
    return DummyPreviewIcon
}

const AdItemWrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 25px -27.5px;
    & > * {
        margin: 0 27.5px;
    }
 `

interface AdItemImageProps {
    filename?: string
    source?: string
}

const AdItemImage = styled.div<AdItemImageProps>`
    flex: 0 0 163px;
    max-width: 133px;
    max-height: 133px;
    height: 133px;
    background-image: url(${props => mapSource(props.filename, props.source)});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
 `

const AdItemDetails = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1 1 auto;
    margin-top: -5px;
    margin-bottom: -5px;
    label {
        margin-top: 13px;
        margin-bottom: 21px;
    }
    .form-group {
        margin: 0 !important;
        padding: 5px 0 !important;
        label { 
            display: none;
        }
    }
 `

const AdItemActions = styled.div`
    flex: 0 0 55px;
    display: flex;
    justify-content: space-between;
    & > img {
        cursor: pointer;
    }
`

interface AdContentProps {
    adState: State<PrintAdPage>
    onRemoveMedia: (id: string) => void
}

const AdItem: React.FC<AdContentProps> = ({ adState, onRemoveMedia }) => {
    const exiState = useExhibitorDataState();
    const ad = useState(adState)
    const downloadItem = useCallback((event: React.MouseEvent<HTMLImageElement>) => {
        event.preventDefault()
        exiState.download(ad.adUrl.get(), ad.name.get())
    }, [exiState, ad])
    return (
        <AdItemWrapper>
            <AdItemImage filename={ad.name.get()} source={ad.adUrl.get()} />
            <AdItemDetails>
                <label>{ad.name.get()}</label>
            </AdItemDetails>
            <AdItemActions>
                <a href={ad.adUrl.get()} download>
                    <Icon src={DownloadIcon} onClick={downloadItem} />
                </a>
                <Icon src={RemoveIcon} onClick={() => onRemoveMedia(ad.id.get())} />
            </AdItemActions>
        </AdItemWrapper>
    );
}
export default AdItem;